
export default function ProductsSection() {
  const products = [
    {
      id: 1,
      name: "Standard Arch Panel System",
      description: "Heavy-duty corrugated steel arch panels designed for standard aircraft protection with excellent weather resistance and structural integrity.",
      image: "https://public.readdy.ai/ai/img_res/89fd0e724139e56a5ce19bcd1bbf072c.jpg",
      features: ["Galvanized steel construction", "Weather-resistant coating", "Modular design", "Easy installation"],
      applications: ["Fighter jets", "Transport aircraft", "Helicopters"]
    },
    {
      id: 2,
      name: "Hardened Military Shelter",
      description: "Reinforced arch panel system engineered for military applications requiring maximum protection against environmental and security threats.",
      image: "https://readdy.ai/api/search-image?query=Heavy%20duty%20military%20aircraft%20shelter%20with%20reinforced%20arch%20structure%2C%20robust%20steel%20construction%2C%20security%20features%2C%20professional%20military%20facility%20design%2C%20neutral%20background&width=600&height=400&seq=hardened-shelter-2&orientation=landscape",
      features: ["Blast-resistant design", "Enhanced security", "Climate control ready", "NBC protection"],
      applications: ["Military bases", "Strategic aircraft", "Defense facilities"]
    },
    {
      id: 3,
      name: "Custom Arch Solutions",
      description: "Tailored arch panel systems designed to meet specific dimensional and operational requirements for unique aviation facilities.",
      image: "https://readdy.ai/api/search-image?query=Custom%20designed%20aircraft%20hangar%20with%20unique%20arch%20configuration%2C%20modern%20engineering%20solution%2C%20specialized%20aviation%20facility%2C%20professional%20architectural%20design%2C%20clean%20industrial%20background&width=600&height=400&seq=custom-arch-3&orientation=landscape",
      features: ["Custom dimensions", "Specialized coatings", "Integrated systems", "Engineering support"],
      applications: ["Commercial aviation", "Private hangars", "Maintenance facilities"]
    }
  ];

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Aircraft Shelter</strong> Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive range of arch panel systems engineered for superior aircraft protection and operational efficiency.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-64">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{product.name}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{product.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Key Features:</h4>
                  <ul className="space-y-1">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className={product.id === 1 ? "mb-0" : "mb-6"}>
                  <h4 className="font-semibold text-gray-900 mb-2">Applications:</h4>
                  <div className="flex flex-wrap gap-2">
                    {product.applications.map((app, index) => (
                      <span key={index} className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                        {app}
                      </span>
                    ))}
                  </div>
                </div>

                {product.id !== 1 && (
                  <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                    Request Quote
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
